<!-- START: dashboard alpha -->
<nav class="cat__core__top-sidebar cat__core__top-sidebar--bg">
    <div class="pull-right">
        <div class="dropdown d-inline-block mb-2 mr-2 mt-2">
        </div>

    </div>

    <span class="cat__core__title d-block mt-2 mb-2">
        <strong>Edit Profile</strong>
    </span>

    <div class="nav-tabs-horizontal">
        <ul class="nav nav-tabs mb-4" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" href="javascript: void(0);" data-toggle="tab" data-target="#profile"
                   role="tab">My Profile</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#emergencyContacts"
                   role="tab">Emergency Contacts</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#settings"
                   role="tab">Settings</a>
            </li>
        </ul>
    </div>

</nav>


<section class="card">
    <div class="card-body">
        <form id="form-validation-simple" name="form-validation-simple" method="POST">

            <div class="nav-tabs-horizontal">
                <div class="tab-content">
                    <!-- Begin Profile Tab -->
                    <div class="tab-pane active" id="profile" role="tabcard">

                        <div class="row">
                            <div class="col-12">
                                <div class="mb-5">
                                    <!-- Popup Form Validation -->
                                    <div class="form-group row">
                                        <div class="col-md-2">
                                            <label>Prefix</label>
                                            <select class="form-control" id="profile-Prefix">
                                                <option>Mr.</option>
                                                <option>Mrs.</option>
                                                <option>Ms.</option>
                                                <option>Miss</option>
                                                <option>Miss</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-4">
                                            <label class="form-control-label" for="profile-FirstName">First Name</label>
                                            <input type="text" class="form-control" placeholder="First Name"
                                                   id="profile-FirstName">
                                        </div>
                                        <div class="col-sm-4">
                                            <label class="form-control-label" for="profile-FirstName">Last Name</label>
                                            <input type="text" class="form-control" placeholder="Last Name"
                                                   id="profile-LastName">
                                        </div>
                                        <div class="col-md-2">
                                            <label>Suffix</label>
                                            <input type="text" class="form-control" placeholder="Suffix"
                                                   id="profile-Suffix">
                                        </div>
                                    </div>
                                    <!-- End Popup Form Validation -->
                                </div>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="mb-5">
                                    <h5 class="text-black"><strong>Email Address</strong>
                                        <small><a href="#" class="primary">Add Email</a></small>
                                    </h5>
                                    <div class="form-group row">
                                        <div class="col-6">
                                            <label>Email Address</label>
                                            <input type="text" class="form-control" placeholder="Email"
                                                   id="profile-email">
                                        </div>
                                        <div class="col-4">
                                            <label>Email Type</label>
                                            <select class="form-control" id="profile-PrimaryEmail-Type">
                                                <option class="form-check">Personal</option>
                                                <option class="form-check">Business</option>
                                            </select>
                                        </div>
                                        <div class="col-2">
                                            <button style="margin-top:34px"
                                                    class="btn btn-sm btn-icon btn-outline-primary mr-2 mb-2"
                                                    type="button"><i aria-hidden="true" class="fa fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-5">
                                    <h5 class="text-black"><strong>Phone Number</strong>
                                        <small><a href="#" class="primary">Add Phone</a></small>
                                    </h5>
                                    <div class="form-group row">
                                        <div class="col-6">
                                            <label>Phone Number</label>
                                            <input type="text" class="form-control" placeholder="Phone Number"
                                                   id="profile-phone">
                                        </div>
                                        <div class="col-4">
                                            <label>Phone Type</label>
                                            <select class="form-control" id="profile-PrimaryPhone-Type">
                                                <option class="form-check">Home</option>
                                                <option class="form-check">Business</option>
                                                <option class="form-check">Cell</option>
                                            </select>
                                        </div>
                                        <div class="col-2">
                                            <button style="margin-top:34px"
                                                    class="btn btn-sm btn-icon btn-outline-primary mr-2 mb-2"
                                                    type="button"><i aria-hidden="true" class="fa fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="mb-5">
                                    <h5 class="text-black"><strong>Insurance & Health Information</strong></h5>
                                    <!-- Under Element Form Validation -->
                                    <div class="form-group">
                                        <label>Insurance Company</label>
                                        <input type="text" class="form-control" placeholder=""
                                               id="insurance-company">
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Current Medical Conditions</label>
                                        <textarea class="form-control" rows="3" id="l15"></textarea>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Current Medications</label>
                                        <textarea class="form-control" rows="3" id="l15"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label>Allergies</label>
                                        <input type="text" class="form-control" placeholder=""
                                               id="insurance-allergies">
                                    </div>
                                    <!-- End Under Element Form Validation -->
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-actions">
                                    <button type="button" class="pull-right btn btn-default remove-error">Undo Changes
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- End Profile Tab -->


                    <!-- Begin Emergency Contact Tab -->
                    <div class="tab-pane" id="emergencyContacts" role="tabcard">
                        <div class="row">
                            <div class="col-12">
                                <div class="mb-5">
                                    <h5 class="text-black"><strong>Emergency Contacts</strong>
                                        <small><a href="#" class="primary">Add Contact</a></small>
                                    </h5>
                                    <div class="form-group row">
                                        <div class="col-5">
                                            <label>Name</label>
                                            <input type="text" class="form-control" placeholder="Name"
                                                   id="ec-name">
                                        </div>
                                        <div class="col-3">
                                            <label>Phone</label>
                                            <input type="text" class="form-control" placeholder="Phone"
                                                   id="ec-phone">
                                        </div>
                                        <div class="col-3">
                                            <label>Phone Type</label>
                                            <select class="form-control" id="ec-phone-Type">
                                                <option class="form-check">Home</option>
                                                <option class="form-check">Business</option>
                                                <option class="form-check">Cell</option>
                                            </select>
                                        </div>
                                        <div class="col-1">
                                            <button style="margin-top:34px"
                                                    class="btn btn-sm btn-icon btn-outline-primary mr-2 mb-2"
                                                    type="button"><i aria-hidden="true" class="fa fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-5">
                                            <label>Relationship</label>
                                            <select class="form-control" id="ec-phone-Type">
                                                <option class="form-check"></option>
                                                <option class="form-check">Spouse</option>
                                            </select>

                                        </div>
                                        <div class="col-4">
                                            <label>Contact For</label>
                                            <select class="form-control" id="ec-phone-Type">
                                                <option class="form-check">Training & Event</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-actions">
                                    <button type="button" class="pull-right btn btn-default remove-error">Undo Changes
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- End Emergency Contact Tab -->


                    <!-- Begin Settings Tab -->
                    <div class="tab-pane" id="settings" role="tabcard">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="mb-5">
                                    <h5 class="text-black"><strong>Change Username and Password</strong></h5>
                                    <div class="form-group">
                                        <label>New LLS Log-in ID</label>
                                        <input type="text" class="form-control" placeholder="Enter new LLS Log-in ID"
                                               id="profile-username">
                                    </div>
                                    <div class="form-group">
                                        <label>New Password</label>
                                        <input type="text" class="form-control" placeholder="Enter new password"
                                               id="profile-password">
                                    </div>
                                    <div class="form-group">
                                        <label>Confirm New Password</label>
                                        <input type="text" class="form-control" placeholder="Re-enter new password"
                                               id="profile-password-confirm">
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="mb-5">
                                    <h5 class="text-black"><strong>Notify me via email when:</strong></h5>
                                    <!-- Under Element Form Validation -->
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="checkbox" name="exampleRadios"
                                                   id="exampleRadios1" value="option1" checked>
                                            Someone comments on my posts
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="checkbox" name="exampleRadios"
                                                   id="exampleRadios2" value="option2">
                                            A new donation is made
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="checkbox" name="exampleRadios"
                                                   id="exampleRadios3" value="option3" disabled>
                                            My fundraising minimum is met
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="checkbox" name="exampleRadios"
                                                   id="exampleRadios3" value="option3" disabled>
                                            My fundraising goal is met
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Settings Tab -->

                </div>
            </div>
        </form>
    </div>
</section>

